// Actions
import AppActions from 'app/shared/flux/actions/AppActions';
import ErrorActions from 'app/shared/flux/actions/ErrorActions';

// Define interfaces for better type safety
interface ReactContext {
  ip: string;
  store: {
    // eslint-disable-next-line no-unused-vars
    dispatch: (action: any) => Promise<any>;
  };
  trace:
    | {
        // eslint-disable-next-line no-unused-vars
        finishAsyncSpan: (params: { marker: string }) => void;
      }
    | null
    | undefined;
}

const loadGeolocation = (reactContext: ReactContext): Promise<any> => {
  const { ip, store, trace } = reactContext;

  return store
    .dispatch(AppActions.getGeoIp({ ip, trace: null }))
    .then((response: any) => {
      if (trace) {
        trace.finishAsyncSpan({
          marker: 'FetchAreaWrapper#loadGeolocationData',
        });
      }
      return response;
    })
    .catch((error: Error) => {
      store.dispatch(
        ErrorActions.errorHandler({
          error,
          errorClass: error.constructor,
          errorLocation: 'AppTemplate#serverRouteWillMount',
          req: {},
          criticalType: null,
        }),
      );
    });
};

export default loadGeolocation;
